import React from 'react';

import { Button } from '@rsc/ui-components/shadcn/Button';
import { cn } from '@rsc/tailwind-base/utils';

interface Props {
  selectedOptions: Record<string, string>;
  handleOptionChange: (...args: unknown[]) => unknown;
  unavailable?: boolean;
  option: {
    name?: string;
  };
  value: string;
}

export default function OptionTag({
  selectedOptions,
  handleOptionChange,
  unavailable = false,
  option,
  value,
}: Readonly<Props>) {
  let buttonClasses = unavailable ? 'opacity-50' : '';
  buttonClasses =
    selectedOptions[option?.name] === value
      ? 'bg-secondary text-secondary-foreground'
      : buttonClasses;
  return (
    <Button
      role="radio"
      variant="outline"
      size="sm"
      className={cn(buttonClasses)}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        handleOptionChange({
          target: {
            name: option?.name,
            value,
          },
        });
      }}
      aria-checked={selectedOptions[option?.name] === value}
      aria-label={value}
    >
      {value}
    </Button>
  );
}
